import React, { Component } from 'react';
import styled from 'styled-components';
import SectionServicesItem from './SectionServicesItem';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

const SectionServicesContainer = styled.section`
    width: 100%;
    padding: 150px 190px 119px;

    @media(max-width: 1919px) {
        padding: 99px 100px 119px;
    }

    @media(max-width: 1365px) {
        padding: 64px 36px 106px;
    }

    @media(max-width: 1023px) {
        padding: 70px 10px 104px;
    }

    @media(max-width: 767px) {
        padding: 61px 16px 71px;
    }
`;

const SectionServicesTitle = styled.div`
    ${FONTS.H1};
    color: ${ COLORS.black };

    @media(max-width: 1919px) {
        ${FONTS.H2};
    }

    @media(max-width: 1365px) {
        ${FONTS.H3};
    }
`;

const SectionServicesitems = styled.div`
    width: 100%;
    margin-top: 72px;
    display: flex;
    justify-content: center;

    @media(max-width: 1919px) {
        margin-top: 52px;
        justify-content: space-between;
    }

    @media(max-width: 1365px) {
        margin-top: 35px;
    }

    @media(max-width: 767px) {
        margin-top: 49px;
    }
`;

export default class SectionServices extends Component {
    render() {
        const { title } = this.props;

        return (
            <SectionServicesContainer>
                <SectionServicesTitle as='h2'>{title}</SectionServicesTitle>

                <SectionServicesitems>
                    <SectionServicesItem
                        icon='/static/images/agent/card.svg'
                        title='Будьте в курсе, за что и когда платили'
                        desc='Быстро оплатить услугу, пополнить счет или посмотреть историю платежей можно прямо в приложении.'
                    />
                    <SectionServicesItem
                        icon='/static/images/agent/paket.svg'
                        title='Новые подарки и акции каждый месяц'
                        desc='Пользуйтесь скидками и бонусами, которые есть только в мобильном приложении.'
                    />
                    <SectionServicesItem
                        icon='/static/images/agent/rub.svg'
                        title='Пользуйтесь услугой сейчас, платите потом'
                        desc='Если услуга нужна, а пополнить счет вы пока не можете — подключите обещанный платёж.'
                    />
                    <SectionServicesItem
                        icon='/static/images/agent/dialog.svg'
                        title='Техподдержка всегда на связи'
                        desc='Пишите по любому вопросу в чат. Ответим даже 1 января.'
                    />
                </SectionServicesitems>
            </SectionServicesContainer>
        );
    }
}
